import { registerPlugin } from "@capacitor/core";
import { StatusBar } from "@capacitor/status-bar";
import { isNativeFeelEnabled } from "@/lib/native/feature-flags";
import { getNativePlatform, isNativeAppPlatform } from "@/lib/native/platform";

type KeyboardResizeMode = "none" | "native" | "body" | "ionic";

type KeyboardPlugin = {
  setResizeMode: (options: { mode: KeyboardResizeMode }) => Promise<void>;
};

const Keyboard = registerPlugin<KeyboardPlugin>("Keyboard");

export async function setupNativeSystemUi(): Promise<void> {
  if (!isNativeAppPlatform() || !isNativeFeelEnabled("systemUi")) return;
  const platform = getNativePlatform();

  try {
    await Keyboard.setResizeMode({ mode: "ionic" });
  } catch {
    // Soft-fail: keep current behavior if Keyboard plugin is unavailable.
  }

  try {
    await StatusBar.setOverlaysWebView({ overlay: platform === "ios" });
  } catch {
    // Soft-fail: keep current behavior if StatusBar plugin is unavailable.
  }
}
